<template>
    <div class="bc-shift">
        <div class="bc-card" :style="{ width }">
            <div v-if="title || eyebrow" class="bc-head">
                <slot name="head-left" />
                <div class="bc-head__text">
                    <div v-if="eyebrow" class="bc-eyebrow">{{ eyebrow }}</div>
                    <div v-if="title" class="bc-title">{{ title }}</div>
                </div>
                <slot name="head-right" />
            </div>
            <slot />
        </div>
    </div>
</template>

<script>
    // The white card every break screen of the live stream sits in (1920x1080, next to the match info on the left)
    export default {
        name: 'BroadcastCard',
        props: {
            title: {
                type: String,
                default: ''
            },
            // small grey line above the title
            eyebrow: {
                type: String,
                default: ''
            },
            width: {
                type: String,
                default: '1150px'
            }
        }
    }
</script>

<style scoped>
/* clears the match info header on the left of the screen */
.bc-shift {
    transform: translateX(300px);
}

@media (max-width: 960px) {
    .bc-shift {
        transform: translateX(3%);
    }
}

.bc-card {
    max-width: calc(100vw - 760px);
    padding: 28px 40px 32px;
    border-radius: 22px;
    background: #fff;
    box-shadow: 0 18px 40px rgba(0, 0, 0, 0.25);
    color: #2b2b2e;
    font-family: Ubuntu, Arial, sans-serif;
    font-weight: 400;
    text-align: left;
}

.bc-head {
    display: flex;
    align-items: center;
    gap: 20px;
    margin-bottom: 22px;
}

.bc-head__text {
    flex: 1;
    min-width: 0;
}

.bc-eyebrow {
    color: rgba(0, 0, 0, 0.5);
    font-size: 1.05rem;
    font-weight: 800;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.bc-title {
    background-image: linear-gradient(90deg, #ef4444 0%, #ff7133 60%, orange 100%);
    background-clip: text;
    -webkit-text-fill-color: transparent;
    font-size: 2.7rem;
    font-weight: 800;
    line-height: 1.15;
}
</style>
